<template>
  <div id="add-item-to-basket-overlay-matrix">
    <div class="modal fade">
      <div
        class="modal-dialog modal-xl"
        role="document"
      >
        <div
          v-if="basketItems"
          class="modal-content"
        >
          <!-- MODAL HEADER -->
          <div class="modal-header">
            <div class="modal-title h5">
              {{ $translate("Ceres::Template.singleItemAdded") }}
            </div>
            <span class="text-muted ml-auto"><span class="timer" />s</span>
            <button
              type="button"
              class="close ml-0 pl-1"
              data-dismiss="modal"
              :aria-label="$translate('Ceres::Template.closeIcon')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-- ./MODAL HEADER -->

          <!-- MODAL BODY -->
          <div class="modal-body">
            <div class="row is-table-row">
              <div
                v-for="(basketItem, index) in basketItems"
                :key="index"
                class="col-12 col-lg-6 mb-3"
              >
                <div class="row">
                  <div
                    class="col-md-4"
                    style="min-height: 80px;"
                  >
                    <lazy-img
                      :image-url="imageUrl"
                      :alt="imageAlternativeText || itemName"
                      :title="itemName"
                      :style="{ maxHeight: '140px' }"
                      picture-class="img-fluid mx-auto"
                    />
                  </div>
                  <div class="col-md-8">
                    <p>
                      <strong>{{ itemName(basketItem) }}</strong>
                    </p>

                    <p class="small">
                      <strong>
                        <span class="text-muted">{{ basketItem.quantity }} x </span>
                        <span>{{ getPrice(basketItem) | currency }}</span>
                      </strong>
                    </p>

                    <p
                      v-for="(attribute, index) in basketItem.variation.data.attributes"
                      :key="index"
                      class="small"
                    >
                      <strong>{{ attribute.attribute.names.name }}</strong>:
                      <span>{{ attribute.value.names.name }}</span>
                    </p>

                    <p
                      v-for="property in basketItem.variation.data.properties"
                      :key="property.property.id"
                      class="small"
                    >
                      <template v-if="orderParamValue(property.property.id)">
                        <strong>{{ orderParamName(basketItem, property.property.id) }} (+ {{ basketItem.variation.data.properties | propertySurcharge(property.property.id) | currency }})</strong>
                        <span v-if="property.property.valueType === 'file'">
                          <a
                            :href="orderParamValue(basketItem, property.property.id) | fileUploadPath"
                            target="_blank"
                          >
                            <i
                              class="fa fa-external-link"
                              aria-hidden="true"
                            />
                            : {{ orderParamValue(basketItem, property.property.id) | fileName }}
                          </a>
                        </span>
                        <span v-else-if="property.property.valueType !== 'empty'"><b>: </b>{{ orderParamValue(basketItem, property.property.id) }}</span>
                      </template>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ./MODAL BODY -->

          <!-- MODAL FOOTER -->
          <div class="modal-footer">
            <a
              v-waiting-animation-infinite
              :href="urls.basket"
              rel="nofollow"
              class="btn btn-outline-primary btn-medium mr-2"
            >
              <i
                class="fa fa-shopping-cart"
                aria-hidden="true"
              />
              {{ $translate("Ceres::Template.singleItemBasket") }}
            </a>
            <a
              v-waiting-animation-infinite
              :href="urls.checkout"
              rel="nofollow"
              class="btn btn-primary btn-medium"
            >
              <i
                class="fa fa-arrow-right"
                aria-hidden="true"
              />
              {{ $translate("Ceres::Template.singleItemCheckout") }}
            </a>
          </div>
          <slot name="extendOverlayButtons" />
          <!-- ./MODAL FOOTER -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isNullOrUndefined } from '../../helper/utils';

const ModalService = require('../../services/ModalService');
const ApiService = require('../../services/ApiService');

export default {

  data () {
    return {
      basketItems: null,
      wipeOverlayInterval: null,
      basketItemsUpdateTemp: false,
      basketItemsAddedTemp: false
    };
  },

  computed:
    {
      urls () {
        return {
          basket: App.urls.basket,
          checkout: App.urls.checkout
        };
      },

      basketItemss () {
        return this.$store.state.basket.items;
      },

      isBasketItemQuantityUpdate () {
        return this.$store.state.basket.isBasketItemQuantityUpdate;
      }
    },

  mounted () {
    if (App.config.basket.addItemToBasketConfirm === 'overlay') {
      this.wipeOverlayInterval = setInterval(() => {
        const overlayEl = $('#add-item-to-basket-overlay');

        if (overlayEl.length) {
          overlayEl.remove();
        }
      }, 500);

      ApiService.listen('AfterBasketItemUpdate', data => {
        const isBasketItemQuantityUpdate = $('body').hasClass('basket-open');
        const updatedBasketItems = data.basketItems;

        data.basketItems.forEach((updatedBasketItem, index) => {
          if (!isBasketItemQuantityUpdate) {
            updatedBasketItems[index] = this.basketItemss.find(item => item.id === updatedBasketItem.id) || {};
            updatedBasketItems[index].quantity = updatedBasketItem.quantity;
            updatedBasketItems[index].price = updatedBasketItem.price;
            updatedBasketItems[index].basketItemOrderParams = updatedBasketItem.basketItemOrderParams;
          }
        });
        if (!isBasketItemQuantityUpdate) {
          this.basketItemsUpdateTemp = updatedBasketItems;
          this.showItemTimeout();
        }
      });
      ApiService.listen('AfterBasketItemAdd', data => {
        this.basketItemsAddedTemp = data.basketItems;
        this.showItemTimeout();
      });
    }
  },

  beforeDestroy () {
    clearInterval(this.wipeOverlayInterval);
  },

  methods: {
    showItemTimeout () {
      setTimeout(() => {
        if (this.basketItemsAddedTemp.length && this.basketItemsUpdateTemp.length) {
          this.showItem([...this.basketItemsAddedTemp, ...this.basketItemsUpdateTemp]);
        } else if (this.basketItemsAddedTemp.length) {
          this.showItem(this.basketItemsAddedTemp);
        } else if (this.basketItemsUpdateTemp.length) {
          this.showItem(this.basketItemsUpdateTemp);
        }

        this.basketItemsUpdateTemp = false;
        this.basketItemsAddedTemp = false;
      }, 100);
    },

    showItem (basketItems) {
      this.basketItems = basketItems;

      const modal = ModalService.findModal(document.getElementById('add-item-to-basket-overlay-matrix'));

      modal.on('shown.bs.modal', function () {
        $(this).before($('.modal-backdrop'));
      });
      modal.setTimeout(120 * 1000)
        .show();
    },

    getPrice (basketItem) {
      const graduatedPrice = this.$options.filters.graduatedPrice(basketItem.variation.data, basketItem.quantity);
      const propertySurcharge = this.$options.filters.propertySurchargeSum(basketItem.variation.data);

      return this.$options.filters.specialOffer(graduatedPrice, basketItem.variation.data.prices, 'price', 'value') + propertySurcharge;
    },

    itemName (basketItem) {
      return this.$options.filters.itemName(basketItem.variation.data);
    },

    imageUrl (basketItem) {
      const images = this.$options.filters.itemImages(basketItem.variation.data.images, 'urlPreview');

      return this.$options.filters.itemImage(images);
    },

    imageAlternativeText (basketItem) {
      const images = this.$options.filters.itemImages(basketItem.variation.data.images, 'urlPreview');

      return this.$options.filters.itemImageAlternativeText(images);
    },

    orderParamName (basketItem, propertyId) {
      if (isNullOrUndefined(basketItem.basketItemOrderParams)) {
        return '';
      }

      const property = basketItem.variation.data.properties.find(property => {
        return parseInt(property.property.id) === parseInt(propertyId);
      });

      if (isNullOrUndefined(property) || !property.property.isOderProperty) {
        return '';
      }

      const orderParam = basketItem.basketItemOrderParams.find(param => {
        return parseInt(param.propertyId) === parseInt(propertyId);
      });

      return orderParam.name;
    },

    orderParamValue (basketItem, propertyId) {
      if (isNullOrUndefined(basketItem.basketItemOrderParams)) {
        return '';
      }

      const property = basketItem.variation.data.properties.find(property => {
        return parseInt(property.property.id) === parseInt(propertyId);
      });

      if (isNullOrUndefined(property) || !property.property.isOderProperty) {
        return '';
      }

      const orderParam = basketItem.basketItemOrderParams.find(param => {
        return parseInt(param.propertyId) === parseInt(propertyId);
      });

      if (isNullOrUndefined(orderParam)) {
        return '';
      }

      const orderParamValue = orderParam.value;

      if (property.property.valueType === 'selection' && orderParamValue) {
        return property.property.selectionValues[orderParamValue].name;
      }
      return orderParamValue;
    }
  }
};
</script>
